import "./DashboardSkeleton.css";

export default function DashboardSkeleton() {
  return (
    <div className="dashboard-skeleton-page">
      <main className="dashboard-skeleton">
        <section className="dashboard-skeleton-header">
          <div className="dashboard-skeleton-title-group">
            <div className="dashboard-skeleton-block dashboard-skeleton-title-line" />
            <div className="dashboard-skeleton-block dashboard-skeleton-title-line dashboard-skeleton-title-line-short" />
            <div className="dashboard-skeleton-block dashboard-skeleton-title-line dashboard-skeleton-title-line-xs" />
          </div>

          <div className="dashboard-skeleton-actions">
            <div className="dashboard-skeleton-button-outline" />
            <div className="dashboard-skeleton-button-outline" />
            <div className="dashboard-skeleton-account">
              <div className="dashboard-skeleton-avatar" />
              <div>
                <div className="dashboard-skeleton-block dashboard-skeleton-account-name" />
                <div className="dashboard-skeleton-block dashboard-skeleton-account-mail" />
              </div>
            </div>
          </div>
        </section>

        <section className="dashboard-skeleton-main-grid">
          <article className="dashboard-skeleton-card dashboard-skeleton-chart-card">
            <div className="dashboard-skeleton-block dashboard-skeleton-card-title" />

            <div className="dashboard-skeleton-donut-wrap">
              <div className="dashboard-skeleton-donut" />
            </div>

            <div className="dashboard-skeleton-legend">
              <div className="dashboard-skeleton-legend-item">
                <span />
                <div className="dashboard-skeleton-block" />
              </div>
              <div className="dashboard-skeleton-legend-item">
                <span />
                <div className="dashboard-skeleton-block" />
              </div>
            </div>
          </article>

          <article className="dashboard-skeleton-card dashboard-skeleton-summary-card">
            <div className="dashboard-skeleton-block dashboard-skeleton-card-title" />
            <div className="dashboard-skeleton-block dashboard-skeleton-big-value" />

            <div className="dashboard-skeleton-accordion">
              <div className="dashboard-skeleton-accordion-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-chevron" />
              </div>
              <div className="dashboard-skeleton-accordion-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-chevron" />
              </div>
              <div className="dashboard-skeleton-accordion-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-chevron" />
              </div>
            </div>
          </article>
        </section>

        <section className="dashboard-skeleton-tabs">
          <div className="dashboard-skeleton-tab dashboard-skeleton-tab-active" />
          <div className="dashboard-skeleton-tab" />
          <div className="dashboard-skeleton-tab" />
        </section>

        <section className="dashboard-skeleton-main-grid">
          <article className="dashboard-skeleton-card">
            <div className="dashboard-skeleton-card-header">
              <div className="dashboard-skeleton-block dashboard-skeleton-card-title-wide" />
              <div className="dashboard-skeleton-block dashboard-skeleton-small-label" />
            </div>

            <div className="dashboard-skeleton-table">
              <div className="dashboard-skeleton-table-head">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
              </div>

              <div className="dashboard-skeleton-table-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
              </div>

              <div className="dashboard-skeleton-table-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
              </div>

              <div className="dashboard-skeleton-table-row">
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
                <div className="dashboard-skeleton-block" />
              </div>
            </div>
          </article>

          <article className="dashboard-skeleton-card">
            <div className="dashboard-skeleton-card-header">
              <div className="dashboard-skeleton-block dashboard-skeleton-card-title-wide" />
              <div className="dashboard-skeleton-block dashboard-skeleton-small-label" />
            </div>

            <div className="dashboard-skeleton-score-grid">
              <div className="dashboard-skeleton-score-card">
                <div className="dashboard-skeleton-block dashboard-skeleton-score-title" />
                <div className="dashboard-skeleton-score-circle" />
                <div className="dashboard-skeleton-block dashboard-skeleton-score-link" />
              </div>

              <div className="dashboard-skeleton-score-card">
                <div className="dashboard-skeleton-block dashboard-skeleton-score-title" />
                <div className="dashboard-skeleton-score-circle dashboard-skeleton-score-circle-dashed" />
                <div className="dashboard-skeleton-block dashboard-skeleton-score-link" />
              </div>
            </div>
          </article>
        </section>

        <section className="dashboard-skeleton-card dashboard-skeleton-bottom-card">
          <div className="dashboard-skeleton-block dashboard-skeleton-card-title-wide" />

          <div className="dashboard-skeleton-wide-table">
            <div className="dashboard-skeleton-table-row">
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
            </div>

            <div className="dashboard-skeleton-table-row">
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
            </div>

            <div className="dashboard-skeleton-table-row">
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
              <div className="dashboard-skeleton-block" />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
